import axios from 'axios';
import { getServerBaseUrl } from './base_url.js';
import { toast } from 'react-toastify';

export const handleAPIRequest = async (
  method,
  url,
  data = null,
  params = null,
  token = null
) => {
  const getBase = getServerBaseUrl();

  let headers = {};

  if (method === 'post' || method === 'put') {
    headers['Content-Type'] = 'multipart/form-data';
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios({
      method,
      url: `${getBase}/${url}`,
      headers,
      data,
      params,
      timeout: 600000,
    });

    return {
      success: true,
      status: response.status,
      data: response.data || null, // Ensure `data` is always returned
      message: "Request successful",
    };
  } catch (error) {
    console.error(error?.response || error, 'API Request Error');

    let errorMessage = 'An unexpected error occurred';
    let errorData = null;

    if (error.response) {
      errorMessage = error.response.data?.message || `Error: ${error.response.status}`;
      errorData = error.response.data || null;
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = "Request timeout";
    } else {
      errorMessage = error.message;
    }

    //toast.error(errorMessage);

    return {
      success: false,
      status: error.response?.status || 500,
      data: errorData, 
      message: errorMessage,
    };
  }
};
